export const fr = {
  title: `Les traitements de l’épilepsie?`,
  drugs: `Médicamenteux`,
  surgery: `Chirurgicaux`,
  alternative: `Autres`
};
